export default {
  projectId: (state) => state.project.id,
  projectSettingsKey: (state) => state.project.settingsKey,
  detailViewLoader: (state) => state.detailView.loading,
  // create project wizard
  createProjectWizardData: (state) => state.createProjectWizard.rawData || {},
  createProjectWizardPageData:
    (state) => (params) => state.createProjectWizard.wizardData[params.page][params.key],
};
